import {Component, Input, OnInit, Self, Optional, HostListener} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl} from '@angular/forms';

@Component({
  selector: 'form-number',
  templateUrl: './number.component.html',
})
export class NumberComponent implements OnInit, ControlValueAccessor {
  @Input() icon: string;
  @Input() name: string;
  @Input() placeholder: string;
  @Input() label: string;
  @Input() required = false;
  @Input() readonly = false;
  @Input() disabled = false;
  @Input() step: number;
  @Input() min: number = 0;
  @Input() max: number = 99999999.99;
  @Input() data: string;
  @Input() list: string;
  @Input() maxlength: number = 10;

  @Input()
  get value(): number {
    // if (!this._value) {
    // return ;
    // } else
    return this._value;
  }

  set value(value: number) {
    // if(value){
    //   this._value = Number(value.toFixed(this._precision));
    // } else {
    //   this._value = value;
    // }
    this._value = value;
    this._onChangeFn(value);
  }

  private _value = 0;
  private _precision = 2;

  // It will have a reference to a function that handles changing state of the control
  private _onChangeFn: (value: any) => void = _ => { };

  constructor(@Self() @Optional() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit() {
    this.setPrecision();
  }

  onChange(input) {
    this._onChangeFn(input.value);
  }

  // validateNumberValue(val) {
  //   // console.log(val);
  //   if (val.includes('.')) {
  //     this.maxlength = this.maxlength + 1;
  //     // val = val.split('.', 2).join('.').substr(0, val.indexOf('.') + this._precision + 1);
  //   }
  //   return val;
  // }

  // allowChar(event) {
  //   const val = event.target.value;
  //   const valLength = val.length;
  //   const charCode =event.keyCode;
  //   const allowed = [...Array(57 - 47 + 1)].map((_, i) => 47 + i).concat([44]);
  //   // console.log(event, val);
  //   // return true;
  //   if (allowed.includes(charCode) && this.maxlength > valLength) {
  //     if (!(',' === String.fromCharCode(charCode) && val.includes('.'))) {
  //       return true;
  //     }
  //   }
  //   return false;
  // }

  // TODO: This should probably be parsed to number
  writeValue(value: any) {
    this.value = this.parseValue(value);
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  registerOnChange(fn) {
    this._onChangeFn = fn;
  }

  // TODO: Implement this
  registerOnTouched(fn) {
  }

  setPrecision() {
    if (this.step) {
      this._precision = this.step.toString().split('.', 2).length;
    }
  }

  parseValue(value: any) {
    let parsedValue = value;
    if (parsedValue) {
      parsedValue = parseFloat(value).toFixed(this._precision);
    }
    return parsedValue;
  }

  // @HostListener('blur', ['$event'])
  onBlur(event) {
    if (this._precision) {
      const input = event.target;
      input.value = this.parseValue(input.value);
    }
  }

}
